import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useEntitlementsData } from '../api/hooks/UseEntitlementsData';
import { setUserContext } from '../utils/newrelic';

import { EntitlementsContext } from './entitlementsContextValue';

export const EntitlementsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { pathname } = useLocation();

  // Only call entitlements API if on a valid path
  const shouldFetchEntitlements =
    pathname === '/' || pathname.startsWith('/details/');

  const {
    data: entitlements,
    error,
    isError,
    isLoading,
  } = useEntitlementsData({ enabled: shouldFetchEntitlements });

  useEffect(() => {
    if (entitlements) {
      setUserContext(
        entitlements.userId,
        entitlements.org ? { org: entitlements.org } : {},
      );
    }
  }, [entitlements]);

  return (
    <EntitlementsContext.Provider
      value={{
        entitlements,
        error: error as Error | null,
        isError,
        isLoading,
        hasEntitlements: shouldFetchEntitlements && !isError && !isLoading,
      }}
    >
      {children}
    </EntitlementsContext.Provider>
  );
};
